export default {
    header: 'Tests',
    unauthorized:
        "Tests are currently in closed beta. You don't have access to these features yet. They will be available soon!",
    error: 'Something went wrong when trying to load the tests. Please try again later.',

    assessmentModule: {
        header: 'Your assessment',
    },

    completedYourProfile: 'You need to complete your profile to get access to this assessment',
    toMyProfile: 'Edit my profile',
};
